import ProfileCard from '@/components/Sherpa/Projects/Project/ProfileCard';

function ProjectTeam({ opportunityState }: { opportunityState: any }) {
  const { projectTeam, vendor } = opportunityState;

  const projectExecutive = (
    <ProfileCard user={projectTeam.projectExecutive} role='Project Executive' image='https://placeimg.com/64/64/people' />
  );

  const developmentManager = (
    <ProfileCard
      user={projectTeam.developmentManager}
      role='Development Manager'
      image='https://i.picsum.photos/id/1/5616/3744.jpg?hmac=kKHwwU8s46oNettHKwJ24qOlIAsWN9d2TtsXDoCWWsQ'
    />
  );

  const developmentAssociates = (
    <ProfileCard
      user={projectTeam.developmentAssociates}
      role='Development Associate'
      image='https://i.picsum.photos/id/1005/5760/3840.jpg?hmac=2acSJCOwz9q_dKtDZdSB-OIK1HUcwBeXco_RMMTUgfY'
    />
  );

  const investmentAssociates = (
    <ProfileCard
      user={projectTeam.investmentAssociates}
      role='Investment Associate'
      image='https://i.picsum.photos/id/1011/5472/3648.jpg?hmac=Koo9845x2akkVzVFX3xxAc9BCkeGYA9VRVfLE4f0Zzk'
    />
  );
  const constructionManager = (
    <ProfileCard
      user={projectTeam.constructionManager}
      role='Construction Manager'
      image='https://i.picsum.photos/id/1011/5472/3648.jpg?hmac=Koo9845x2akkVzVFX3xxAc9BCkeGYA9VRVfLE4f0Zzk'
    />
  );

  const qaqc = (
    <ProfileCard
      user={projectTeam.qcqa}
      role='QA/QC'
      image='https://i.picsum.photos/id/1011/5472/3648.jpg?hmac=Koo9845x2akkVzVFX3xxAc9BCkeGYA9VRVfLE4f0Zzk'
    />
  );

  return (
    <div className='w-full mt-8 mb-16'>
      <section className='grid gap-8 grid-cols-1'>
        <div className=''>
          <h2 className='m-0 p-0 font-bold text-lg mb-8'>Project Team</h2>
          <section className='grid grid-cols-3 lg:grid-cols-4 gap-4'>
            {projectExecutive}
            {developmentManager}
            {developmentAssociates}
            {investmentAssociates}
            {constructionManager}
            {qaqc}
          </section>
        </div>
        <div className=''>
          <h2 className='m-0 p-0 font-bold text-lg mb-8'>Vendor</h2>
          <section className='grid grid-cols-4 gap-8'>
            <ProfileCard user={vendor.architect} role='Architect' image='https://placeimg.com/120/80/tech' />
            <ProfileCard user={vendor.civilEngineer} role='Civil Engineer' image='https://placeimg.com/120/80/arch?1' />
            <ProfileCard
              user={vendor.structuralEngineer ? vendor.structuralEngineer : 'None'}
              role='Structural Engineer'
              image='https://placeimg.com/120/80/arch?2'
            />
            <ProfileCard user={vendor.generalContractor} role='General Contractor' image='https://placeimg.com/120/80/arch' />
          </section>
        </div>
      </section>
    </div>
  );
}
export default ProjectTeam;
